import {AbstractModel} from "./abstract-model";
import {Partner} from './partner';
import {Country} from './country';

export class Config extends AbstractModel {
  partner: Partner | null = null;
  roles: string[] | null = null;
  data: any;
  countries: Country[] = [];

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.partner) {
      this.partner = new Partner().deserialize(input.partner);
    }

    if (input.countries) {
      this.countries = input.countries.map((data: any) => new Country().deserialize(data));
    }

    return this;
  }
}
